/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cockpit_LedeInputs */

const tr_landing_cockpit_lede = /** @type {(inputs: Landing_Cockpit_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her pazaryerine dilediğiniz kadar mağaza bağlayın, ek ücret ödemeden. Sipariş, stok, kargo ve iadelerinizi tek yerden yönetin; komisyon ve kargo sonrası gerçek kârınızı anlık görün.`)
};

const en_landing_cockpit_lede = /** @type {(inputs: Landing_Cockpit_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect as many stores per marketplace as you like, at no extra cost. Manage orders, stock, shipping and returns in one place, and see your real profit after commissions and shipping in real time.`)
};

const de_landing_cockpit_lede = /** @type {(inputs: Landing_Cockpit_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinden Sie pro Marktplatz beliebig viele Shops, ohne Aufpreis. Verwalten Sie Bestellungen, Bestand, Versand und Retouren an einem Ort und sehen Sie Ihren echten Gewinn nach Provisionen und Versandkosten in Echtzeit.`)
};

const ru_landing_cockpit_lede = /** @type {(inputs: Landing_Cockpit_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключайте к каждому маркетплейсу сколько угодно магазинов без доплаты. Управляйте заказами, остатками, доставкой и возвратами из одного места и отслеживайте реальную прибыль после комиссий и доставки в режиме реального времени.`)
};

/**
* | output |
* | --- |
* | "Connect as many stores per marketplace as you like, at no extra cost. Manage orders, stock, shipping and returns in one place, and see your real profit after..." |
*
* @param {Landing_Cockpit_LedeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_cockpit_lede = /** @type {((inputs?: Landing_Cockpit_LedeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cockpit_LedeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_cockpit_lede(inputs)
	if (locale === "de") return de_landing_cockpit_lede(inputs)
	if (locale === "ru") return ru_landing_cockpit_lede(inputs)
	return tr_landing_cockpit_lede(inputs)
});